import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config"
import {log} from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

export const getValidityPurchaseOptions = async (token) => {
    log("welcome in getValidityPurchaseOptions")

    if (!token || token === "") {
        return {error: true, message: "No token provided", options: [], services: []}
    }

    try {
        const url = BASE_URL + '/home/get_validity_purchase_options_api'
        const result = await axios.get(url, {headers: getHeaders(token)})
        log("result.data from getValidityPurchaseOptions")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getValidityPurchaseOptions")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la incarcarea optiunilor de valabilitate", options: [], services: []}
    }
}

export const createValidityPurchaseOption = async (token, data) => {
    log("welcome in createValidityPurchaseOption")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/create_validity_purchase_option_api'
        const result = await axios.post(url, data, {headers: getHeaders(token)})
        log("result.data from createValidityPurchaseOption")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in createValidityPurchaseOption")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la crearea optiunii"}
    }
}

export const updateValidityPurchaseOption = async (token, id, data) => {
    log("welcome in updateValidityPurchaseOption")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/update_validity_purchase_option_api'
        const result = await axios.put(url, {id, ...data}, {headers: getHeaders(token)})
        log("result.data from updateValidityPurchaseOption")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in updateValidityPurchaseOption")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la actualizarea optiunii"}
    }
}

export const deleteValidityPurchaseOption = async (token, id) => {
    log("welcome in deleteValidityPurchaseOption")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/delete_validity_purchase_option_api'
        const result = await axios.delete(url, {
            headers: getHeaders(token),
            data: {id}
        })
        log("result.data from deleteValidityPurchaseOption")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in deleteValidityPurchaseOption")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la stergerea optiunii"}
    }
}

export const getSimCredit = async (token, simId) => {
    log("welcome in getSimCredit")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/get_sim_credit_api'
        const result = await axios.get(url, {
            headers: getHeaders(token),
            params: {sim_id: simId}
        })
        log("result.data from getSimCredit")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getSimCredit")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la verificarea creditului"}
    }
}

export const purchaseValidity = async (token, simId, optionId) => {
    log("welcome in purchaseValidity")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/purchase_validity_api'
        const result = await axios.post(url, {
            sim_id: simId,
            option_id: optionId
        }, {headers: getHeaders(token)})
        log("result.data from purchaseValidity")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in purchaseValidity")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la achizitia valabilitatii"}
    }
}

// ==========================================
// VALIDITY OPTION LIMITS (admin only)
// ==========================================

export const getValidityOptionLimits = async (token) => {
    log("welcome in getValidityOptionLimits")

    if (!token || token === "") {
        return {error: true, message: "No token provided", limits: [], distributors: []}
    }

    try {
        const url = BASE_URL + '/home/get_validity_option_limits_api'
        const result = await axios.get(url, {headers: getHeaders(token)})
        log("result.data from getValidityOptionLimits")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getValidityOptionLimits")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la incarcarea limitelor", limits: [], distributors: []}
    }
}

export const createValidityOptionLimit = async (token, data) => {
    log("welcome in createValidityOptionLimit")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/create_validity_option_limit_api'
        const result = await axios.post(url, data, {headers: getHeaders(token)})
        log("result.data from createValidityOptionLimit")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in createValidityOptionLimit")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la crearea limitelor"}
    }
}

export const updateValidityOptionLimit = async (token, id, data) => {
    log("welcome in updateValidityOptionLimit")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/update_validity_option_limit_api'
        const result = await axios.put(url, {id, ...data}, {headers: getHeaders(token)})
        log("result.data from updateValidityOptionLimit")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in updateValidityOptionLimit")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la actualizarea limitelor"}
    }
}

export const deleteValidityOptionLimit = async (token, id) => {
    log("welcome in deleteValidityOptionLimit")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/delete_validity_option_limit_api'
        const result = await axios.delete(url, {
            headers: getHeaders(token),
            data: {id}
        })
        log("result.data from deleteValidityOptionLimit")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in deleteValidityOptionLimit")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la stergerea limitelor"}
    }
}

export const getValidityLimitsForClient = async (token, clientId = null) => {
    log("welcome in getValidityLimitsForClient")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/get_validity_limits_for_client_api'
        const params = clientId ? {client_id: clientId} : {}
        const result = await axios.get(url, {
            headers: getHeaders(token),
            params
        })
        log("result.data from getValidityLimitsForClient")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getValidityLimitsForClient")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la incarcarea limitelor"}
    }
}

const useValidityPurchaseOptionsAPI = () => {
    return {
        error,
        getValidityPurchaseOptions,
        createValidityPurchaseOption,
        updateValidityPurchaseOption,
        deleteValidityPurchaseOption,
        getSimCredit,
        purchaseValidity,
        // Limits
        getValidityOptionLimits,
        createValidityOptionLimit,
        updateValidityOptionLimit,
        deleteValidityOptionLimit,
        getValidityLimitsForClient
    }
}

export default useValidityPurchaseOptionsAPI
